var map = {
	"./assets/displayedText": "aca6",
	"./assets/displayedText.ts": "aca6",
	"./assets/fonts/Avant_Garde/AvantGarde.css": "b872",
	"./assets/fonts/Avant_Garde/ITC Avant Garde Gothic Medium.woff": "ea85",
	"./assets/fonts/Camingos_Dos/CamingoDos-Pro-ExtraLight.ttf": "a40a",
	"./assets/fonts/Camingos_Dos/CamingoDos-Pro-ExtraLight.woff": "111b",
	"./assets/fonts/Camingos_Dos/CamingoDos-Pro-SemiBold.ttf": "9e77",
	"./assets/fonts/Camingos_Dos/CamingoDos-Pro-SemiBold.woff": "e414",
	"./assets/fonts/Camingos_Dos/CamingoDos.css": "0f22",
	"./assets/fonts/Lato/Lato-Black.ttf": "8b51",
	"./assets/fonts/Lato/Lato-Black.woff": "cce8",
	"./assets/fonts/Lato/Lato-BlackItalic.ttf": "f519",
	"./assets/fonts/Lato/Lato-Bold.ttf": "70fd",
	"./assets/fonts/Lato/Lato-BoldItalic.ttf": "e362",
	"./assets/fonts/Lato/Lato-Italic.ttf": "346c",
	"./assets/fonts/Lato/Lato-Light.ttf": "8102",
	"./assets/fonts/Lato/Lato-Light.woff": "df44",
	"./assets/fonts/Lato/Lato-LightItalic.ttf": "0b0d",
	"./assets/fonts/Lato/Lato-Regular.ttf": "db51",
	"./assets/fonts/Lato/Lato-Thin.ttf": "0739",
	"./assets/fonts/Lato/Lato-ThinItalic.ttf": "54fa",
	"./assets/fonts/Lato/Lato.css": "9a15",
	"./assets/fonts/Lato/OFL.txt": "7832",
	"./assets/fonts/Lidl_Cond_Pro/LidlCondPro.css": "09e9",
	"./assets/fonts/Lidl_Cond_Pro/LidlFontCondPro-Bold.woff2": "17da",
	"./assets/fonts/Lidl_Cond_Pro/LidlFontCondPro-BoldItalic.woff2": "12c2",
	"./assets/fonts/Lidl_Cond_Pro/LidlFontCondPro-Book.woff2": "a7e8",
	"./assets/fonts/Lidl_Cond_Pro/LidlFontCondPro-BookItalic.woff2": "8758",
	"./assets/fonts/Lidl_Cond_Pro/LidlFontCondPro-Italic.woff2": "befa",
	"./assets/fonts/Lidl_Cond_Pro/LidlFontCondPro-Regular.woff2": "7f8d",
	"./assets/fonts/Lidl_Cond_Pro/LidlFontCondPro-Semibold.woff2": "74cb",
	"./assets/fonts/Lidl_Cond_Pro/LidlFontCondPro-SemiboldItalic.woff2": "6a7e",
	"./assets/fonts/Lidl_Pro/LidlFontPro-Bold.woff2": "16bb",
	"./assets/fonts/Lidl_Pro/LidlFontPro-BoldItalic.woff2": "851d",
	"./assets/fonts/Lidl_Pro/LidlFontPro-Book.woff2": "4528",
	"./assets/fonts/Lidl_Pro/LidlFontPro-BookItalic.woff2": "e53e",
	"./assets/fonts/Lidl_Pro/LidlFontPro-Italic.woff2": "1109",
	"./assets/fonts/Lidl_Pro/LidlFontPro-Regular.woff2": "5971",
	"./assets/fonts/Lidl_Pro/LidlPro.css": "bf56",
	"./assets/fonts/Lidl_Script_Pro/LidlFontScriptPro.woff2": "f6ca",
	"./assets/fonts/Lidl_Script_Pro/LidlScriptPro.css": "8462",
	"./assets/fonts/Museo_Sans/Museo-Sans-700.ttf": "0b91",
	"./assets/fonts/Museo_Sans/Museo-Sans-700.woff": "b35f",
	"./assets/fonts/Museo_Sans/MuseoSans.css": "8f7b",
	"./assets/fonts/Open_Sans/OpenSans.css": "5896",
	"./assets/fonts/Open_Sans/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06FxZCJgvAQ.woff2": "6668",
	"./assets/fonts/Open_Sans/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtE6FxZCJgvAQ.woff2": "0caa",
	"./assets/fonts/Open_Sans/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtU6FxZCJgvAQ.woff2": "8395",
	"./assets/fonts/Open_Sans/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWtk6FxZCJgvAQ.woff2": "d3d6",
	"./assets/fonts/Open_Sans/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWu06FxZCJgvAQ.woff2": "7292",
	"./assets/fonts/Open_Sans/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6FxZCJgg.woff2": "6a4d",
	"./assets/fonts/Open_Sans/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuk6FxZCJgvAQ.woff2": "a72b",
	"./assets/fonts/Open_Sans/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWvU6FxZCJgvAQ.woff2": "b409",
	"./assets/fonts/Open_Sans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-mu0SC55I.woff2": "0174",
	"./assets/fonts/Open_Sans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS2mu0SC55K5gw.woff2": "3b79",
	"./assets/fonts/Open_Sans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSCmu0SC55K5gw.woff2": "bde9",
	"./assets/fonts/Open_Sans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu0SC55K5gw.woff2": "a3e5",
	"./assets/fonts/Open_Sans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSKmu0SC55K5gw.woff2": "5bb8",
	"./assets/fonts/Open_Sans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSOmu0SC55K5gw.woff2": "953e",
	"./assets/fonts/Open_Sans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSumu0SC55K5gw.woff2": "e884",
	"./assets/fonts/Open_Sans/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSymu0SC55K5gw.woff2": "05a1",
	"./assets/fonts/Robot_Slab/RobotoSlab-VariableFont_wght.ttf": "58f8",
	"./assets/fonts/Robot_Slab/RobotoSlab-VariableFont_wght.woff": "51f7",
	"./assets/fonts/Robot_Slab/RobotoSlab.css": "f481",
	"./assets/fonts/Santos/Burnaby Stencil.ttf": "912b",
	"./assets/fonts/Santos/Gothic.woff": "83a3",
	"./assets/fonts/Santos/LeagueGothic-Regular-VariableFont_wdth.ttf": "63a4",
	"./assets/fonts/Santos/Oswald-Regular.ttf": "7f29",
	"./assets/fonts/Santos/Oswald-Regular.woff": "14e3",
	"./assets/fonts/Santos/Santos.css": "4712",
	"./assets/fonts/Staatliches/Staatliches-Regular.ttf": "232d",
	"./assets/fonts/Staatliches/Staatliches-Regular.woff": "898b",
	"./assets/fonts/Staatliches/Staatliches.css": "354f",
	"./assets/fonts/Zilla_Slab/ZillaSlab.css": "f827",
	"./assets/fonts/Zilla_Slab/dFa4ZfeM_74wlPZtksIFaj8K8VSMdFJ6dZX9.woff2": "47e4",
	"./assets/fonts/Zilla_Slab/dFa4ZfeM_74wlPZtksIFaj8K_1SMdFJ6dQ.woff2": "5b10",
	"./assets/fonts/Zilla_Slab/dFa5ZfeM_74wlPZtksIFYoEf6H2pW3pwfa3Efg.woff2": "af23",
	"./assets/fonts/Zilla_Slab/dFa5ZfeM_74wlPZtksIFYoEf6HOpW3pwfa0.woff2": "8bd7",
	"./assets/fonts/Zilla_Slab/dFa5ZfeM_74wlPZtksIFYpEY6H2pW3pwfa3Efg.woff2": "a0b3",
	"./assets/fonts/Zilla_Slab/dFa5ZfeM_74wlPZtksIFYpEY6HOpW3pwfa0.woff2": "64fb",
	"./assets/fonts/Zilla_Slab/dFa5ZfeM_74wlPZtksIFYskZ6H2pW3pwfa3Efg.woff2": "11d9",
	"./assets/fonts/Zilla_Slab/dFa5ZfeM_74wlPZtksIFYskZ6HOpW3pwfa0.woff2": "1747",
	"./assets/fonts/Zilla_Slab/dFa5ZfeM_74wlPZtksIFYuUe6H2pW3pwfa3Efg.woff2": "3550",
	"./assets/fonts/Zilla_Slab/dFa5ZfeM_74wlPZtksIFYuUe6HOpW3pwfa0.woff2": "43a0",
	"./assets/fonts/Zilla_Slab/dFa6ZfeM_74wlPZtksIFajQ6_V6LVlBKdA.woff2": "fbb4",
	"./assets/fonts/Zilla_Slab/dFa6ZfeM_74wlPZtksIFajo6_V6LVlA.woff2": "3f33",
	"./assets/fonts/Zilla_Slab/dFanZfeM_74wlPZtksIFaj8CDHeZV3B3X6_0f1Nk.woff2": "70aa",
	"./assets/fonts/Zilla_Slab/dFanZfeM_74wlPZtksIFaj8CDHeZWXB3X6_0fw.woff2": "350b",
	"./assets/fonts/Zilla_Slab/dFanZfeM_74wlPZtksIFaj8CIHCZV3B3X6_0f1Nk.woff2": "bf5a",
	"./assets/fonts/Zilla_Slab/dFanZfeM_74wlPZtksIFaj8CIHCZWXB3X6_0fw.woff2": "ecd5",
	"./assets/fonts/Zilla_Slab/dFanZfeM_74wlPZtksIFaj8CRHGZV3B3X6_0f1Nk.woff2": "49c0",
	"./assets/fonts/Zilla_Slab/dFanZfeM_74wlPZtksIFaj8CRHGZWXB3X6_0fw.woff2": "169c",
	"./assets/fonts/Zilla_Slab/dFanZfeM_74wlPZtksIFaj8CVHaZV3B3X6_0f1Nk.woff2": "f1bd",
	"./assets/fonts/Zilla_Slab/dFanZfeM_74wlPZtksIFaj8CVHaZWXB3X6_0fw.woff2": "2891",
	"./assets/img/Arrowleft.svg": "ba21",
	"./assets/img/Heart.svg": "f639",
	"./assets/img/MenuPoints.svg": "367f",
	"./assets/img/Spoon.svg": "0cd4",
	"./assets/img/blob.svg": "16a6",
	"./assets/img/bot-logo.png": "06c8",
	"./assets/img/bubble_hinter_objekt.svg": "1ddf",
	"./assets/img/bubblearrow.svg": "5e89",
	"./assets/img/ja_aktiv.svg": "65e0",
	"./assets/img/magnifying-glass-solid (1).svg": "3c68",
	"./assets/img/nein_aktiv.svg": "cbb9",
	"./assets/img/paperplane.svg": "3147",
	"./assets/img/printer.svg": "19ad",
	"./assets/img/silverware_variant_icon_137189.svg": "81af",
	"./assets/img/slider_button.svg": "8f76",
	"./assets/img/speechbubble_arrow.png": "1b40",
	"./assets/img/thumbs-down-solid.svg": "1ce1",
	"./assets/img/thumbs-up-solid.svg": "279b",
	"./assets/img/vs.svg": "b51f",
	"./assets/scss/main.scss": "c1c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";